var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("QueryList", {
    attrs: {
      "page-title": _vm.$t("sfe.route.sop18"),
      "page-name": _vm.pageName,
      "api-module": _vm.apiModule,
      "query-dom-data": _vm.domData,
      "query-data": _vm.searchQuery,
      "table-buttons": _vm.tableButtons,
      "table-dom": _vm.tableDom,
      "list-api": _vm.listApi,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }